<template>
  <div class="modal-container" id="confirmAttachModal">
    <div class="modal-body">
      <h5 style="margin-bottom: 5px;">Attention, l'association de la demande à un client SAP existant est irréversible !</h5>
      <p style="margin-bottom: 20px;">Pensez à vérifier <strong>manuellement</strong> les adresses et représentants légaux du client SAP après association car les informations du prospect ne seront pas reprises.</p>
      <p style="font-weight: bold; font-size: 16px; margin-bottom: 5px;">Votre sélection</p>
      <p style="margin-bottom: 20px;">
        Client SAP séléctionné : {{ customer.name }}<br />
        Représentant principal : {{ candidateIdentityMainRepresentative(customer.main_representative) }}
      </p>
      <button @click="$emit('confirm', true)" class="btn btn-success">
        <span>Confirmer</span>
      </button>
      <button @click="$emit('cancel', true)" class="btn">
        <span>Annuler</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
    name:"Step2Modal",

    props:["customer"],

    methods: {
      candidateIdentityMainRepresentative(candidate) {
        if (candidate)
          return candidate.decoded_representative_quality + ' ' + candidate.decoded_civility + ' ' + candidate.first_name + ' ' + candidate.last_name
        return "Données manquantes"
      },
    },

    mounted () {
      $('html, body').animate({
                    scrollTop: $("#confirmAttachModal").offset().top
                }, 2000)
    }
}
</script>

<style scoped>
.modal-container {
  position: absolute;
  background-color: rgba(0 , 0 , 0 , 0.5);
  height: 100%;
  width: -webkit-fill-available;
  z-index: 999;
}

.modal-body {
  background-color: white;
  position: relative;
  top: 25%;
  text-align: center;
}



/*div {
    width: 420px;
    height: 200px;
    border: 1px solid;
    overflow-y: scroll;
}*/

</style>



// WEBPACK FOOTER //
// client/components/Demands/Modals/Step2Modal.vue